import { useCallback, useEffect, useState } from 'react';

/**
 * Toast nhẹ dùng chung cho các section Cài đặt (mock UI).
 * Dùng CSS class `.coa-toast` đã có sẵn.
 */
export function useToast(autoHideMs = 2400) {
  const [toast, setToast] = useState<string | null>(null);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), autoHideMs);
    return () => clearTimeout(t);
  }, [toast, autoHideMs]);

  const showToast = useCallback((msg: string) => setToast(msg), []);
  const clearToast = useCallback(() => setToast(null), []);

  return { toast, showToast, clearToast };
}
